import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';
import { showSuccessToast, showErrorAlert } from '../utils/alert';
import './LoginPage.css';

const OtpVerificationPage = () => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false); // Loading untuk verifikasi utama
  const [isResending, setIsResending] = useState(false); // <-- 1. State loading BARU untuk tombol resend
  
  const [cooldown, setCooldown] = useState(30);
  const [isCooldownActive, setCooldownActive] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  
  const { userId, email } = location.state || {};

  // Efek untuk timer cooldown (tidak berubah)
  useEffect(() => {
    if (!isCooldownActive) return;
    const timerId = setInterval(() => {
      setCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(timerId);
          setCooldownActive(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timerId);
  }, [isCooldownActive]);

  // Efek untuk redirect jika data tidak ada (tidak berubah)
  useEffect(() => {
    if (!userId || !email) {
      console.error("Data registrasi tidak lengkap. Mengalihkan...");
      navigate('/register');
    }
  }, [userId, email, navigate]);

  // Handler untuk verifikasi OTP (tidak berubah)
  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('/api/users/verify-otp', { userId, otp });
      showSuccessToast(response.data.message);
      navigate('/login');
    } catch (error) {
      showErrorAlert(error.response?.data?.message || 'Verifikasi gagal.');
      setLoading(false);
    }
  };

  // --- 2. PERBAIKAN PADA FUNGSI RESEND ---
  const handleResend = async () => {
    if (isCooldownActive || isResending) return; // Jangan lakukan apa-apa jika cooldown atau sedang mengirim

    setIsResending(true); // Langsung set loading
    try {
      const response = await api.post('/api/users/resend-otp', { userId });
      showSuccessToast(response.data.message);
      // Mulai ulang cooldown setelah berhasil
      setCooldown(30);
      setCooldownActive(true);
    } catch (error) {
      showErrorAlert(error.response?.data?.message || 'Gagal mengirim ulang OTP.');
    } finally {
      setIsResending(false); // Hentikan loading, baik berhasil maupun gagal
    }
  };
  
  // Handler input OTP (tidak berubah)
  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value)) {
      setOtp(value);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  // --- 3. Tentukan teks dan status disabled untuk tombol resend ---
  const resendButtonText = () => {
    if (isResending) return 'Mengirim...';
    if (isCooldownActive) return `Kirim ulang dalam ${cooldown}d`;
    return 'Kirim Ulang Kode';
  };

  return (
    <div className="login-page-container">
      <form className="login-form-card" onSubmit={handleVerify}>
      <div className="login-header">
        <h1 className="login-title">Verifikasi Email</h1>
        <p className="login-subtitle">
          {`Silakan cek email (${email || '...'}) untuk mendapatkan kode OTP!`}
        </p>
      </div>
        <div className="form-group">
          <label htmlFor="otp">Kode OTP</label>
          <input
            type="tel"
            id="otp"
            value={otp}
            onChange={handleOtpChange}
            placeholder="OTP"
            required
            maxLength="6"
            pattern="[0-9]*"
            inputMode="numeric"
            autoComplete="one-time-code"
            style={{ textAlign: 'center', fontSize: '24px', letterSpacing: '10px' }}
          />
        </div>
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Memverifikasi...' : 'Verifikasi'}
        </button>

        <div className="otp-actions-container">
          <button type="button" onClick={handleGoBack} className="link-button">
            &larr; Salah Email? Kembali
          </button>
          <button 
            type="button" 
            onClick={handleResend} 
            disabled={isCooldownActive || isResending} // <-- 4. Tombol dinonaktifkan jika cooldown atau sedang mengirim
            className="link-button"
          >
            {resendButtonText()}
          </button>
        </div>
      </form>
    </div>
  );
};

export default OtpVerificationPage;